import React from "react";
import { Formik } from "formik";

import { Button, DialogModal, LoadMask, Page } from "../../../../components";
import FilterIndicator from "../../../../components/FilterIndicator";
import OrderDetail from "../../order/order-list-layout/orderDetail";
import OrdersTable from "./ordersTable";
import Filters from "./filters";
import { USER_ROLES } from "../../../../constants";
import { RoutePaths } from "../../../../constants/RoutePaths";
import {
  preOrderFieldNames,
  preOrderFiltersInitialState,
} from "./filters/constants";
import {
  DetailWrapper,
  PageWrapper,
  ActionButtonsWrapper,
  ActionButtonsTitle,
  ActionsButtons,
  ExportButton,
} from "./styles";
import usePreOrderList from "./usePreOrderList";

const PreOrderList = ({
  userData,
  preOrderOnCancelFinished,
  loadingPreOrderOnCancelDialog,
  handleConfirmCancelPreOrder,
  requestApprovePreOrder,
  loadingPreOrderOnApprovalDialog,
  preOrderOnApprovalFinished,
  handleDownloadPreOrder,
  handleResetCancelState,
  handleResetApprovalState,
}) => {
  const {
    loading,
    preOrderDetailData,
    preOrderResponse,
    orderData,
    currentPage,
    itemsPerPage,
    isCancelPreOrderDialog,
    isApprovePreOrderDialog,
    id,
    title,
    canApprove,
    canCancel,
    promotionalCicle,
    isAgent,
    isEmployee,
    appliedFilters,
    countAppliedFilters,
    showFilterIndicator,
    search,
    authorList,
    onRequestAuthorList,
    handlePageChange,
    handleItemsPerPageChange,
    handleSearchOutput,
    handleFiltersChange,
    handleClearFilter,
    handleClearSearch,
    onCloseDialog,
    onCloseApproveDialog,
    onCancelSelectedData,
    onApproveClick,
  } = usePreOrderList({
    handleDownloadPreOrder,
    handleResetCancelState,
    handleResetApprovalState,
    userData,
  });

  if (!userData || !userData.userRole) {
    return <LoadMask />;
  }

  return (
    <Page
      userData={userData}
      title={`${title}`}
      openDrawer={false}
      originPath={RoutePaths.ORDER}
      originPathName="Pedidos"
      actualPath="Detalhes do pedido"
      fullWidthContent
      orderTypeTitle={preOrderResponse?.orderTypeCategory}
    >
      <DetailWrapper>
        {id && (
          <OrderDetail
            userData={userData}
            isLoadingTable={loading}
            orderNumber={id}
            orderData={orderData}
            orderDetailData={preOrderDetailData}
            promotionalCicle={promotionalCicle}
            openApproveOrderDialog={() => {}}
            openRefuseOrderDialog={() => {}}
            openCancelOrderDialog={() => {}}
          />
        )}
      </DetailWrapper>

      <PageWrapper>
        <ActionButtonsWrapper>
          <ActionButtonsTitle>Lista de pré pedidos</ActionButtonsTitle>
          <ActionsButtons>
            <Button
              size="large"
              color="secondary"
              variant="contained"
              onClick={onApproveClick}
              disabled={!canApprove || isAgent || isEmployee}
            >
              Aprovar pré-pedidos
            </Button>
          </ActionsButtons>
        </ActionButtonsWrapper>

        <Formik
          initialValues={{
            [preOrderFieldNames.CREATE_DATE]:
              preOrderFiltersInitialState[preOrderFieldNames.CREATE_DATE],
            [preOrderFieldNames.AUTHOR]:
              preOrderFiltersInitialState[preOrderFieldNames.AUTHOR],
            [preOrderFieldNames.STATUS]:
              preOrderFiltersInitialState[preOrderFieldNames.STATUS],
          }}
          onSubmit={handleFiltersChange}
          enableReinitialize
        >
          {({ handleReset }) => (
            <>
              <Filters
                onSearch={handleSearchOutput}
                appliedFilters={appliedFilters}
                authorList={authorList}
                onRequestAuthorList={onRequestAuthorList}
              />
              {showFilterIndicator ? (
                <FilterIndicator
                  userData={userData}
                  onClear={() => handleClearFilter(handleReset)}
                  onClearSearch={() => handleClearSearch(handleReset)}
                  appliedFilters={countAppliedFilters}
                  searchTerm={search.term}
                  hideExport
                  listCountResults={preOrderResponse?.list?.length || 0}
                />
              ) : null}
            </>
          )}
        </Formik>

        <OrdersTable
          userData={userData}
          data={preOrderResponse?.list || []}
          loading={loading}
          currentPage={currentPage}
          totalItems={preOrderResponse?.total || 0}
          itemsPerPage={itemsPerPage}
          onPageChange={handlePageChange}
          onChangeItemsPerPage={handleItemsPerPageChange}
          multiselect={
            userData.userRole !== USER_ROLES.MASTER ||
            (userData.userRole === USER_ROLES.MASTER && !!userData.companyName)
          }
          radiobutton={false}
          checkboxesControl={null}
          onCancelSelectedData={onCancelSelectedData}
          canCancel={!canCancel}
        />

        <DialogModal
          title={
            preOrderOnApprovalFinished
              ? "Pré-pedidos aprovados"
              : "Aprovar pré-pedidos"
          }
          description={
            preOrderOnApprovalFinished
              ? "Pronto, pré-pedidos pendentes foram aprovados."
              : "Tem certeza que deseja aprovar todos os pré-pedidos pendentes?"
          }
          cancelButtonText={preOrderOnApprovalFinished ? "Cancelar" : "Fechar"}
          hideConfirmButton={preOrderOnApprovalFinished}
          confirmButtonText="Prosseguir assim mesmo"
          handleCloseDialog={onCloseApproveDialog}
          loadingDialog={loadingPreOrderOnApprovalDialog}
          handleConfirmDialog={() => {
            requestApprovePreOrder(isApprovePreOrderDialog.orderId);
          }}
          isOpenDialog={isApprovePreOrderDialog.open}
        />

        <DialogModal
          title={
            preOrderOnCancelFinished
              ? "Pré-pedido cancelado"
              : "Cancelar pré-pedido"
          }
          description={
            preOrderOnCancelFinished
              ? ""
              : "Tem certeza que deseja cancelar este pré-pedido?"
          }
          cancelButtonText={preOrderOnCancelFinished ? "Fechar" : "Voltar"}
          hideConfirmButton={preOrderOnCancelFinished}
          confirmButtonText="Cancelar pré-pedido"
          handleCloseDialog={onCloseDialog}
          loadingDialog={loadingPreOrderOnCancelDialog}
          handleConfirmDialog={() => {
            handleConfirmCancelPreOrder(
              isCancelPreOrderDialog.id,
              false,
              isCancelPreOrderDialog.preOrderId
            );
          }}
          isOpenDialog={isCancelPreOrderDialog.open}
        />
        {loading ? <LoadMask /> : null}
      </PageWrapper>
    </Page>
  );
};

export default PreOrderList;
